const Avatar = ({avator, onSetMember, ...props}) => {
    return <img {...props} onClick={() => onSetMember()} className={'avatar'} src={avator.img}/>

}

export default Avatar;